import React from "react";
import ReactDOM from "react-dom";
import SubsidyPage from "../../components/SubsidyPage";
import { findModels } from "../../../../infrastructure/repository/benefit-models-repository";

function renderSubsidyPage({ model, recurrentSubsidy, alertId }) {
  ReactDOM.render(
    <SubsidyPage
      model={model}
      recurrentSubsidy={recurrentSubsidy}
      alertId={alertId}
    />,
    document.getElementById("page-container")
  );
}

export async function displaySubsidyPage(
  { model, recurrentSubsidy, alertId } = {
    recurrentSubsidy: false,
    alertId: null,
  }
) {
  renderSubsidyPage({ model, recurrentSubsidy, alertId });
}

export async function displaySubsidyPageById({ modelId, alertId }) {
  const { data: models } = await findModels();

  displaySubsidyPage({
    model: models.find((m) => m.id === modelId),
    recurrentSubsidy: false,
    alertId,
  });
}
